function addSwatchTrigger() {
    const csSwatchTrigger = document.querySelectorAll('.collections-swatch:not(.processed)'); // Select only unprocessed elements
    csSwatchTrigger.forEach((trigger) => {
        trigger.addEventListener('click', function(e) {
            const imageUrl = this.getAttribute('data-image').trim();
            const hoverImageUrl = this.getAttribute('data-hover-image').trim();
            const deactivateOverlay = this.getAttribute('data-overlay');
            const productId = this.getAttribute('data-id');

            const imageElement = document.getElementById(`image--${productId}`);
            const hoverImageElement = document.getElementById(`hover-image--${productId}`);
            const wrapperElement = document.getElementById(`collections-swatches--${productId}`);

            if (imageElement) {
                imageElement.setAttribute('src', imageUrl);
                imageElement.srcset = imageUrl;

                if (deactivateOverlay === 'true') {
                  imageElement.classList.add('deactivate-image-overlay')  
                } else {
                  imageElement.classList.remove('deactivate-image-overlay')  
                }
            }
            if (hoverImageElement) {
                hoverImageElement.setAttribute('src', hoverImageUrl);
                hoverImageElement.srcset = hoverImageUrl;
                
                if (deactivateOverlay === 'true') {
                  hoverImageElement.classList.add('deactivate-image-overlay')  
                } else {
                  hoverImageElement.classList.remove('deactivate-image-overlay')  
                }
            }

            if (wrapperElement) {
                var children = wrapperElement.children;
                Array.prototype.forEach.call(children, function(child) {
                    child.classList.remove('active');
                });
            }

            this.classList.add("active");
        });

        trigger.classList.add('processed'); // Mark element as processed to avoid re-adding the event listener
    });
}

function handleNewElements(mutationsList, observer) {
    for (let mutation of mutationsList) {
        if (mutation.type === 'childList') {
            for (let node of mutation.addedNodes) {
                if (node.nodeType === 1 && node.matches('.grid__item')) {
                  addSwatchTrigger(); // Call only if new relevant elements are added
                }
                if (node.nodeType === 1 && node.matches('.collection')) {
                  addSwatchTrigger(); // Call only if new relevant elements are added
                }
            }
        }
    }
}
document.addEventListener("DOMContentLoaded", (event) => {
    addSwatchTrigger();
});

const targetNode = document.body;
const config = { childList: true, subtree: true };
const observer = new MutationObserver(handleNewElements);

observer.observe(targetNode, config);
